import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
// media-segment
// include media-segment css
import '@vfde-brix/youtube-video/dist/styles.css';
import '@vfde-brix/video/dist/styles.css';
import '@vfde-brix/image/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/headline/dist/styles.css';
import '@vfde-brix/media-segment/dist/styles.css';
import { createMediaSegmentBlock } from '@vfde-brix/media-segment';
// tabs
import '@vfde-brix/tabs/dist/styles.css';
import { createTabsComponent } from '@vfde-brix/tabs';
import { createComponents } from '../../utils/initComponents';

const initPattern = (createFunction: any, className: string) => {
    createComponents(className, createFunction, NO_PATTERN_BUSINESS_LOGIC);
};

initPattern(createTabsComponent, 'brix-tabs');
initPattern(createMediaSegmentBlock, 'brix-media-segment');
